export default __webpack_public_path__ + "static/media/canmera.0a172722.obj";